<!--提现记录-->
<template>
  <a-card :bordered="false" title="提现记录" class="withdrawal-record-page">
    <search-page-view
      ref="pageList"
      :col="3"
      :itemNames="searchItemList"
      :buttonItems="['exportButton']"
      :columns="getColumns()"
      :queryParams="queryParams"
      :requestPromise="getWithdrawalListPromise"
      :showResetButton="true"
      row-key="withdrawalNo"
      :leftSpace="36"
      @reset="resetEvent"
    >
      <a-form-item slot="search_submitDate" label="提交日期" v-bind="searchItemLayout">
        <a-range-picker
          :value="selectedSubmitDate"
          format="YYYY-MM-DD"
          style="width: 100%"
          @change="onSubmitDateChange"
        />
      </a-form-item>

      <a-form-item slot="search_status" label="状态" v-bind="searchItemLayout">
        <a-select allowClear style="width: 100%" v-model="queryParams.status" placeholder="请选择">
          <a-select-option v-for="item in statusList" :key="item.code" :value="item.code">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <a-button slot="exportButton" style="margin-left: 8px" @click="exportData">导出</a-button>

      <template slot="operation">
        <a-button type="primary" @click="handleAdd"
        >
          <a-icon type="plus"/>
          新增提现
        </a-button>
      </template>

      <template slot="withdrawalAmount" slot-scope="rowItem">
        ￥{{ rowItem.record.withdrawalAmount || rowItem.record.amount || '0.00' }}
      </template>

      <template slot="invoiceVoucher" slot-scope="rowItem">
        <div v-if="getInvoiceAttachmentList(rowItem.record).length" class="invoice-attachment-list">
          <a
            v-for="(item, index) in getInvoiceAttachmentList(rowItem.record)"
            :key="index"
            :href="item"
            target="_blank"
            class="invoice-attachment-item"
          >
            <img v-if="isImageFile(item)" :src="item" alt="发票凭证" class="invoice-attachment-image"/>
            <span v-else>附件{{ index + 1 }}</span>
          </a>
        </div>
        <span v-else>-</span>
      </template>

      <template slot="status" slot-scope="rowItem">
        {{ getStatusName(rowItem.record.status) }}
      </template>
    </search-page-view>

    <new-withdrawal-request
      :visible.sync="newWithdrawalVisible"
      :submit-promise="createWithdrawalPromise"
      @success="onWithdrawalSuccess"
    />
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'
import NewWithdrawalRequest from '@/views/finance/components/NewWithdrawalRequest'

export default {
  name: 'WithdrawalRecord',
  components: { NewWithdrawalRequest },
  mixins: [searchForm],
  data() {
    return {
      selectedSubmitDate: undefined,
      searchItemList: [
        'search_submitDate',
        'search_status',
        'search_withdrawalNo'
      ],
      queryParams: {
        merchantId: this.$store.getters.userInfo ? this.$store.getters.userInfo.merchantId : 0,
        submitDateStart: '',
        submitDateEnd: '',
        withdrawalNo: ''
      },
      statusList: [
        { code: 1, name: '待审核' },
        { code: 2, name: '已通过' },
        { code: 3, name: '已拒绝' }
      ],
      newWithdrawalVisible: false
    }
  },
  methods: {
    getWithdrawalListPromise(params) {
      const requestParams = {
        ...params,
        merchantId: params.merchantId || 0,
        status: params.status || 0,
        submitDateStart: params.submitDateStart || '',
        submitDateEnd: params.submitDateEnd || '',
        withdrawalNo: params.withdrawalNo || ''
      }
      return this.getHttpServices().getOrderService().post('/platform/v3/withdrawal/getWithdrawalList', requestParams)
    },
    onSubmitDateChange(dates, dateStrArr) {
      this.selectedSubmitDate = dates
      this.queryParams.submitDateStart = dateStrArr[0]
      this.queryParams.submitDateEnd = dateStrArr[1]
    },
    resetEvent() {
      this.selectedSubmitDate = undefined
      this.queryParams = {
        merchantId: this.$store.getters.userInfo ? this.$store.getters.userInfo.merchantId : 0,
        status: 0,
        submitDateStart: '',
        submitDateEnd: '',
        withdrawalNo: ''
      }
      this.$refs.pageList.refresh(true)
    },
    exportData() {
      this.$message.warn('请接入提现记录导出接口')
    },
    handleAdd() {
      this.newWithdrawalVisible = true
    },
    createWithdrawalPromise(params) {
      const requestParams = {
        amount: Number(params.amount),
        invoiceAttachment: params.invoiceAttachment || ''
      }
      return this.getHttpServices()
        .getOrderService()
        .post('/platform/v3/withdrawal/createWithdrawal', requestParams)
    },
    onWithdrawalSuccess() {
      this.$refs.pageList.refresh(true)
    },
    getStatusName(status) {
      const item = this.statusList.find(item => item.code === Number(status))
      return item ? item.name : '-'
    },
    getInvoiceAttachmentList(record = {}) {
      const value = record.invoiceAttachment || record.invoiceVoucher || record.invoiceVoucherUrl || ''
      if (Array.isArray(value)) {
        return value.filter(Boolean)
      }
      if (typeof value === 'string') {
        return value.split(',').map(item => item.trim()).filter(Boolean)
      }
      return []
    },
    isImageFile(url) {
      const path = String(url || '').split('?')[0].toLowerCase()
      return /\.(png|jpe?g|gif|webp|bmp|heic|heif)$/.test(path)
    },
    getColumns() {
      return [
        {
          title: '提现ID',
          dataIndex: 'withdrawalNo',
          width: 120
        },
        {
          title: '提交时间',
          dataIndex: 'submitTime',
          width: 170
        },
        {
          title: '提现金额',
          dataIndex: 'withdrawalAmount',
          width: 120,
          scopedSlots: { customRender: 'withdrawalAmount' }
        },
        {
          title: '发票凭证',
          dataIndex: 'invoiceAttachment',
          scopedSlots: { customRender: 'invoiceVoucher' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          width: 100,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '审核备注',
          dataIndex: 'auditRemark'
        }
      ]
    }
  }
}
</script>

<style scoped lang="less">
.withdrawal-record-page {
  width: 100%;

  /deep/ .ant-card-body {
    padding: 24px 32px;
  }

  /deep/ .ant-table-thead > tr > th {
    font-weight: 600;
    color: #111;
    background: #fafafa;
  }

  /deep/ .ant-table-tbody > tr > td {
    padding: 16px 8px;
  }

  .invoice-attachment-list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
  }

  .invoice-attachment-item {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    min-height: 40px;
  }

  .invoice-attachment-image {
    width: 44px;
    height: 44px;
    object-fit: cover;
    border: 1px solid #e8e8e8;
    border-radius: 2px;
  }
}
</style>
